// External libraries
import React from 'react';
import { useStoreActions, useStoreState } from '@/store';
import { CurrencyConversionOptions } from '@checkout/react-components';
import { css } from '@emotion/core';

// Internal modules
import { SectionHeading } from '@/components/Headings';
import { CI, getContent, logger, useEndCiWith, useMountLogging } from '@/lib';
import { getDisclosures, getIofDisclosure, getTotal } from './utils';
import { PROCESS_CURRENCY_CONVERSION_SELECTION } from './fpti';
import {
  getStyleOverrides,
  getVendorDisclosureStyle,
  vendorDisclosureYellowStyle,
} from './StyledComponents';
import {
  FONT_SIZE_MEDIUM,
  FONT_WEIGHT_NORMAL_PP,
} from '@/styles/styleVariables';

const CurrencyConversion = props => {
  useMountLogging('CurrencyConversion');
  useEndCiWith(CI.Event.CURRENCY_CONVERSION_RENDER, CI.Status.Ok);
  const conversionData = useStoreState(({ api }) => api.currencyConversionData);
  const selectedOption = useStoreState(
    ({ form }) => form.currencyConversionSelection,
  );
  const updateOption = useStoreActions(
    ({ form }) => form.updateCurrencyConversionSelection,
  );
  const { from: fromCurrency, to: toCurrency } = conversionData;
  const changeHandler = (event, selection) => {
    logger.fpti(
      'conversion_selection_change',
      PROCESS_CURRENCY_CONVERSION_SELECTION(selection),
    );
    updateOption(selection);
  };

  return (
    <div data-testid="currency-conversion">
      <SectionHeading
        fontSize={FONT_SIZE_MEDIUM}
        fontWeight={FONT_WEIGHT_NORMAL_PP}
        styleOverrides={css({
          margin: '18px 0',
        })}
      >
        {getContent('currencyConversion.header')}
      </SectionHeading>

      <CurrencyConversionOptions
        styleOverrides={{
          ...getStyleOverrides(),
          ...getVendorDisclosureStyle(),
          ...vendorDisclosureYellowStyle(),
        }}
        changeHandler={changeHandler}
        conversionOptions={[
          { label: fromCurrency.currencyCode, value: 'PAYPAL' },
          { label: toCurrency.currencyCode, value: 'VENDOR' },
        ]}
        disclosures={getDisclosures(conversionData)}
        selectedConversionOption={selectedOption}
        total={getTotal(selectedOption, conversionData)}
        {...getIofDisclosure()}
      />
    </div>
  );
};

export { CurrencyConversion };
